// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608270148/js/" + chunkId + "." + {"44":"a96acc22","225":"84c2dea9","481":"36c31073","486":"59481eb9","770":"8edec60c"}[chunkId] + ".0.2737465331511215.chunk.js";
};